"use client"

import { Kanban } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `KanbanIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const KanbanIcon = component(Icon)({ as: Kanban })
